export default () => {
  if (typeof window !== 'undefined' && window.document && window.document.createElement) {
    const w = window;
    const d = document;
    const { documentElement } = d;
    const body = d.getElementsByTagName('body')[0];
    const width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    return width;
  }
  return null;
};
